"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : InputFormSide.js
* Description : Ce fichier contient la définition du composant InputFormSide
*               Ce composant affiche un champ sur le coté de la page pour rentrer une donnée 
*               avec une fonction de validation de cette donnée
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* InputForm : affiche un champ pour rentrer des données avec une dimension adaptée pour un affichage 
*             sur le coté de la page
*
* Type : composant 
*
* Parametres : 
*  - error -- booléen pour remonter une erreur de validation de la donnée
*  - type -- type de la donnée (text, number, password...)
*  - label -- texte affiché au dessus du champ pour apporter des précisions sur la donnée à rentrer
*  - value -- valeur de la donnée
*  - setValue -- fonction pour mettre à jour la valeur de la donnée
*/function InputFormSide(_ref) {
  var error = _ref.error,
    type = _ref.type,
    label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue;
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "form-side-label flex-column",
    children: [label, ":", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-side-input-error",
      type: type,
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "form-side-label flex-column",
    children: [label, ":", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-side-input",
      type: type,
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      }
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
InputFormSide.propTypes = {
  error: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setValue: _propTypes["default"].func
};
var _default = exports["default"] = InputFormSide;